import { lifecycle, compose, branch, renderNothing, renderComponent, withProps } from 'recompose'
import { connect } from 'react-redux'
import { actions } from '../../modules/staffs'
import TryAgain from '../../components/TryAgain'
import Loading from '../../components/Loading'

const failed = ({ failFetchStaff }) => !!failFetchStaff
const isFetching = ({ fetchingStaff }) => fetchingStaff
const isInitial = ({ failFetchStaff, fetchingStaff, successFetchStaff, currentStaff }) => !failFetchStaff && !fetchingStaff && !successFetchStaff && !currentStaff

const fetchStaffCallback = ({ match: { params: { staff_id } }, currentDealer, fetchStaff, user }) => () => {
  user && fetchStaff({ dealer_id: currentDealer.id, staff_id })
}

const nonOptimalStates = (states) =>
  compose(...states.map(state =>
    branch(state.when, state.render)))

const withLifeCycle = lifecycle({
  componentDidMount() {
    fetchStaffCallback(this.props)()
  },
  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }
})

const withState = connect(state => ({
  currentStaff: state.staffs.currentStaff,
  fetchingStaff: state.staffs.fetchingStaff,
  failFetchStaff: state.staffs.failFetchStaff,
  successFetchStaff: state.staffs.successFetchStaff,
  currentDealer: state.dealers.currentDealer,
  user: state.auth.user
}),
  {
    fetchStaff: actions.fetchStaff,
    resetState: actions.resetState
  }
)

const StaffLoading = withProps({ label: 'Loading Staff Member' })(Loading)
const StaffTryAgain = withProps(({ failFetchStaff, ...props }) => ({
  label: failFetchStaff,
  onTryAgain: fetchStaffCallback(props)
})(TryAgain))

const withFetchingStates = nonOptimalStates([
  {
    when: isFetching,
    render: renderComponent(StaffLoading)
  },
  {
    when: failed,
    render: renderComponent(StaffTryAgain)
  },
  {
    when: isInitial,
    render: renderNothing
  }
])

export default compose(
  withState,
  withLifeCycle,
  withFetchingStates
)
